class MegaMenuOffset extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.align = () => {
      const { x } = this.getBoundingClientRect();
      document.body.style.setProperty("--mega-menu-left-offset", `${x}px`);
    };

    this.align();

    window.addEventListener("resize", this.align);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.align);
  }
}

if (!customElements.get("mega-menu-offset")) {
  customElements.define("mega-menu-offset", MegaMenuOffset);
}
